/**
 * Navigation Configuration
 * 
 * Centralized configuration for navigation color options and settings
 */

export interface ColorOption {
  key?: string;
  name: string;
  color: string;
}

export const ACCENT_COLOR_OPTIONS: ColorOption[] = [
  { key: 'gold', name: 'Gold', color: '#D4AF37' },
  { key: 'blue', name: 'Blue', color: '#3B82F6' },
  { key: 'purple', name: 'Purple', color: '#8B5CF6' },
  { key: 'green', name: 'Green', color: '#10B981' },
  { key: 'red', name: 'Red', color: '#EF4444' }
];

export interface TextColorOptions {
  title: ColorOption[];
  body: ColorOption[];
}

export const getTextColorOptions = (currentTheme: string, currentMode: string): TextColorOptions => {
  if (currentMode === 'light') {
    return {
      title: [
        { name: 'Dark Blue', color: '#1E3A8A' },
        { name: 'Dark Purple', color: '#6B21A8' },
        { name: 'Dark Green', color: '#166534' },
        { name: 'Dark Red', color: '#991B1B' },
        { name: 'Dark Orange', color: '#C2410C' },
        { name: 'Dark Teal', color: '#0F766E' },
        { name: 'Dark Pink', color: '#BE185D' },
        { name: 'Dark Indigo', color: '#3730A3' },
        { name: 'Dark Emerald', color: '#047857' },
        { name: 'Charcoal', color: '#1F2937' }
      ],
      body: [
        { name: 'Blue', color: '#2563EB' },
        { name: 'Purple', color: '#7C3AED' },
        { name: 'Green', color: '#16A34A' },
        { name: 'Red', color: '#DC2626' },
        { name: 'Orange', color: '#EA580C' },
        { name: 'Teal', color: '#0D9488' },
        { name: 'Pink', color: '#DB2777' },
        { name: 'Indigo', color: '#4F46E5' },
        { name: 'Emerald', color: '#059669' },
        { name: 'Gray', color: '#4B5563' }
      ]
    };
  } else if (currentTheme === 'sepia') {
    return {
      title: [
        { name: 'Dark Brown', color: '#4A3728' },
        { name: 'Brown', color: '#6B4423' },
        { name: 'Tan', color: '#8B5A2B' },
        { name: 'Saddle Brown', color: '#8B4513' },
        { name: 'Dark Tan', color: '#5D4037' },
        { name: 'Coffee', color: '#3E2723' }
      ],
      body: [
        { name: 'Medium Brown', color: '#7A5C42' },
        { name: 'Light Brown', color: '#9B7653' },
        { name: 'Darker Brown', color: '#6B5446' },
        { name: 'Sepia', color: '#8B7355' },
        { name: 'Warm Brown', color: '#A0522D' },
        { name: 'Muted Brown', color: '#8B6F47' }
      ]
    };
  } else {
    // dark theme
    return {
      title: [
        { name: 'Light Blue', color: '#60A5FA' },
        { name: 'Light Purple', color: '#A78BFA' },
        { name: 'Light Green', color: '#4ADE80' },
        { name: 'Light Red', color: '#F87171' },
        { name: 'Light Orange', color: '#FB923C' },
        { name: 'Light Teal', color: '#2DD4BF' },
        { name: 'Light Pink', color: '#F472B6' },
        { name: 'Light Indigo', color: '#818CF8' },
        { name: 'Light Emerald', color: '#34D399' },
        { name: 'Pure White', color: '#FFFFFF' }
      ],
      body: [
        { name: 'Soft Blue', color: '#93C5FD' },
        { name: 'Soft Purple', color: '#C4B5FD' },
        { name: 'Soft Green', color: '#86EFAC' },
        { name: 'Soft Red', color: '#FCA5A5' },
        { name: 'Soft Orange', color: '#FDBA74' },
        { name: 'Soft Teal', color: '#5EEAD4' },
        { name: 'Soft Pink', color: '#F9A8D4' },
        { name: 'Soft Indigo', color: '#A5B4FC' },
        { name: 'Soft Emerald', color: '#6EE7B7' },
        { name: 'Light Gray', color: '#D1D5DB' }
      ]
    };
  }
};

